/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCheckFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaIconCheckFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCheckFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 49,
  height = 48,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#3F9142"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCheckFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 49 48"
 style={{'--as-1-1e92VY': alignSelf,'--mt-2-1e92VY': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1e92VY': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1e92VY': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1e92VY': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1e92VY': opacity,'--w-10-1e92VY': typeof width === 'number' ? `${width}px` : width,'--h-11-1e92VY': typeof height === 'number' ? `${height}px` : height,'--f-12-1e92VY': fill,'--a-7-1e92VY': isAnimated ? animation : "none",'--sd-8-1e92VY': isAnimated ? strokeDashoffset : 0,'--sd-9-1e92VY': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCheckFilled.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M24.5 44c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20zm10.008-25.09a2.143 2.143 0 00-3.347-2.677l-10.13 12.664-4.053-3.04a2.143 2.143 0 00-2.572 3.429l5.714 4.285a2.143 2.143 0 002.96-.375L34.507 18.91z"
 style={{'--f-12-1e92VY': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}